import { gql } from '@apollo/client';
import {
    DriverActivityAdminDetail,
    DriverActivityAdminFiltersInput,
    DriverActivityAdminPage,
    DriverActivityRenderedRuleText,
    DriverActivityRuleTemplate,
    DriverActivitySiteOption,
    PreviewDriverActivityRuleTextInput,
} from './types';

const LOG_FIELDS = `
    id
    operation
    operatorId
    operatorName
    description
    createdAt
`;

export const PAGE_DRIVER_ACTIVITY_ADMIN = gql`
    query PageDriverActivityAdmin($filters: DriverActivityAdminFiltersInput, $page: Int!, $size: Int!) {
        pageDriverActivityAdmin(filters: $filters, page: $page, size: $size) {
            items {
                id
                name
                type
                status
                startDate
                endDate
                latestLog {
                    ${LOG_FIELDS}
                }
            }
            page
            size
            total
        }
    }
`;

export interface PageDriverActivityAdminResponse {
    pageDriverActivityAdmin: DriverActivityAdminPage;
}

export interface PageDriverActivityAdminVariables {
    filters?: DriverActivityAdminFiltersInput;
    page: number;
    size: number;
}

export const GET_DRIVER_ACTIVITY_ADMIN_DETAIL = gql`
    query GetDriverActivityAdminDetail($id: Long!) {
        getDriverActivityAdminDetail(id: $id) {
            id
            name
            type
            status
            startDate
            endDate
            weekCount
            signUpDeadline
            bannerS3Key
            bannerUrl
            needSignUp
            needRealName
            maxRewardAmount
            rules {
                scopeId
                hubIds
                warehouseIds
                levels {
                    level
                    dailyDeliverQty
                    targetAttendDays
                    rewardAmount
                }
            }
            ruleText {
                language
                sections {
                    key
                    content
                }
            }
            offlineReason
            offlineTime
            logs {
                ${LOG_FIELDS}
            }
            createdAt
            updatedAt
        }
    }
`;

export interface GetDriverActivityAdminDetailResponse {
    getDriverActivityAdminDetail: DriverActivityAdminDetail;
}

export interface GetDriverActivityAdminDetailVariables {
    id: number;
}

export const GET_DRIVER_ACTIVITY_RULE_TEMPLATE = gql`
    query GetDriverActivityRuleTemplate {
        getDriverActivityRuleTemplate {
            sections {
                key
                order
                required
                defaultVariables
            }
            variables
            languages
            sectionMaxLength
            allowSignUpDuringActivity
            defaultTexts {
                language
                sections {
                    key
                    content
                }
            }
        }
    }
`;

export interface GetDriverActivityRuleTemplateResponse {
    getDriverActivityRuleTemplate: DriverActivityRuleTemplate;
}

export const PREVIEW_DRIVER_ACTIVITY_RULE_TEXT = gql`
    query PreviewDriverActivityRuleText($input: PreviewDriverActivityRuleTextInput!) {
        previewDriverActivityRuleText(input: $input) {
            language
            sections {
                key
                title
                content
                segments {
                    text
                    variable
                }
            }
        }
    }
`;

export interface PreviewDriverActivityRuleTextResponse {
    previewDriverActivityRuleText: DriverActivityRenderedRuleText;
}

export interface PreviewDriverActivityRuleTextVariables {
    input: PreviewDriverActivityRuleTextInput;
}

export const LIST_DRIVER_ACTIVITY_SITE_OPTIONS = gql`
    query ListDriverActivitySiteOptions {
        listDriverActivitySiteOptions {
            hubId
            hubName
            warehouses {
                id
                name
            }
        }
    }
`;

export interface ListDriverActivitySiteOptionsResponse {
    listDriverActivitySiteOptions: DriverActivitySiteOption[];
}
